<template>
  <module-block
    class="home-hero"
    block="transparent"
  >
    <div class="home-hero__inner group group--first group--last">
      <div class="home-hero__content">
        <h1 class="home-hero__heading h1 mt0 fw-semibold" v-html="hero.heading"/>
        <p
          v-for="(copy, index) in hero.content"
          :key="index"

          class="home-hero__copy p"

          v-html="copy"
        />
      </div>
      <div class="home-hero__get-started">
        <div class="home-hero__form">
          <h4 class="h4 mt0">Get your dental work verified now</h4>
          <module-form
            form-id="hero-procedure"
            :fields="{
              procedure: {
                label: `Procedure Type`,
                labelHidden: true,
                type: `select`,
                placeholder: `Select your procedure`,
                items: items,
              },
            }"

            button="primary"
            button-size="m"
            submit="Continue"

            :action="action"
          />
        </div>
      </div>
    </div>
  </module-block>
</template>

<script>
// Vuex
import { mapGetters, mapActions } from 'vuex';

// Services
import { arrayLoop } from 'services/array';

// Modules
import ModuleBlock from 'modules/Block';
import ModuleForm from 'modules/Form';

// Export
export default {
  name: `home-hero`,

  // Components
  components: {
    ModuleBlock,
    ModuleForm,
  },

  // Data
  data () {
    return {
      hero: {
        heading: `Ensure quality dental care`,
        content: [
          `How do you judge the clinical quality of a root canal?`,
          `We created VeriTooth as a way to help patients and dentists validate the quality of work patients receive.`,
          `<b>Let the work speak for itself</b>`,
          `VeriTooth essentially performs a "spot check" on your x-rays to confirm if the work was done within dental industry standards and guidelines.  All work is reviewed by an independent specialist and your identity is hidden.  It’s completely secure, unbiased, and impartial`,
        ],
      },
    };
  },
  computed: {
    ...mapGetters(`forms`, [
      `getModel`,
    ]),
    ...mapGetters(`auth`, [
      `isAuthenticated`,
    ]),
    ...mapGetters(`review`, [
      `reviewNomenclature`,
    ]),
    items() {
      const items = [];

      arrayLoop(this.reviewNomenclature.procedure || [], (i, v) => {
        items.push({
          option: v.name,
          value: v.id,
        });
      });

      return items;
    },
  },

  // Methods
  methods: {
    ...mapActions(`review`, [
      `getNomenclature`,
    ]),
    action() {
      const model = this.getModel(`hero-procedure`);
      sessionStorage.setItem(`procedure`, model.procedure);

      return new Promise(resolve => {
        setTimeout(() => {
          resolve();
        }, 500);

        setTimeout(() => {
          if(!this.isAuthenticated) {
            this.$router.push({
              name: `register-patient`,
              query: {
                redirect: `request`,
              },
            });
          } else {
            this.$router.push({
              name: `request`,
            });
          }
        }, 1000);
      });
    },
  },

  // Lifecycle
  created() {
    this.getNomenclature();
  },
};
</script>



// WEBPACK FOOTER //
// Hero.vue?fe2a6e1e